import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import { deletePrintStation } from '../../../../actions';

class PrintStationDeleteButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
    };
  }

  onClickDelete = () => {
    const { dispatchDeletePrintStation, printStationId } = this.props;

    dispatchDeletePrintStation({ printStationId });
  };

  onClickShowModal = () => this.setState({ showModal: true });

  onClickCancel = () => this.setState({ showModal: false });

  render() {
    const { showModal } = this.state;

    const warningModal = (
      <ConfirmationModal
        show={showModal}
        onClickConfirm={this.onClickDelete}
        onClickCancel={this.onClickCancel}
      />
    );

    const deleteButton = (
      <Button color="danger" onClick={this.onClickShowModal}>
        Eliminar
      </Button>
    );

    return (
      <Fragment>
        {deleteButton}
        {warningModal}
      </Fragment>
    );
  }
}

PrintStationDeleteButton.propTypes = {
  printStationId: PropTypes.number.isRequired,
  dispatchDeletePrintStation: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchDeletePrintStation: deletePrintStation,
};

export default connect(null, mapDispatchToProps)(PrintStationDeleteButton);
